import { Button, Input } from 'semantic-ui-react'
import * as React from 'react'
import {
  BtnClearFormatting,
  BtnStrikeThrough,
  BtnNumberedList,
  EditorProvider,
  BtnBulletList,
  BtnUnderline,
  HtmlButton,
  Separator,
  BtnItalic,
  Toolbar,
  BtnLink,
  BtnRedo,
  BtnBold,
  BtnUndo,
  Editor,
} from 'react-simple-wysiwyg'

import NoteTemplatesDropdown from '../../NoteTemplatesDropdown'
import SaveAsTemplateBtn from '../../SaveAsTemplateBtn'

import { Collection } from '../../../types'

// import { useApi } from '../../../store/mainContext'
import styled from 'styled-components'

const StyledEditorWrapper = styled.div`
  .rsw-editor {
    min-height: 400px;
  }
`

function getStorageKey(relatedId: string) {
  return 'interview-editor.' + relatedId
}

interface Props {
  relatedCollection: Collection
  relatedId: string
  onSuccess(): Promise<any>
  onCancel?(): void
  formId?: string
}

export default function InterviewForm(props: Props) {
  const {
    // relatedCollection,
    // onSuccess,
    relatedId,
    onCancel,
    formId = 'note-form',
  } = props

  // const api = useApi()

  const [isSaving] = React.useState(false)

  const [interview, setInterview] = React.useState<{
    notes: string
    transcript: string
    videoLink: string
  }>({
    notes: window.localStorage.getItem(getStorageKey(relatedId)) || '',
    transcript: '',
    videoLink: '',
  })

  const cleanupForm = () => {
    window.localStorage.removeItem(getStorageKey(relatedId))
    setInterview({ notes: '', transcript: '', videoLink: '' })
  }

  const handleOnChange = (newValue: string) => {
    window.localStorage.setItem(getStorageKey(relatedId), newValue)
    setInterview({ ...interview, notes: newValue })
  }

  // const onSubmit: SubmitHandler<FormValues> = async (data) => {
  //   setIsSaving(true)
  //   // return api
  //   //   .post('events', {
  //   //     description: data.body,
  //   //     title: data.category,
  //   //     type: 'note',
  //   //     relatedId,
  //   //     relatedCollection,
  //   //   })
  //   //   .then(() => onSuccess())
  //   //   .then(cleanupForm)
  //   //   .catch((err: AxiosError) => {
  //   //     addToast(err.response?.data.message || err.message, {
  //   //       variant: 'danger',
  //   //     })
  //   //   })
  //   //   .finally(() => setIsSaving(false))
  // }

  return (
    <div className="mt-6">
      <div className="mb-2">
        <b>Interview Notes</b>
      </div>
      <StyledEditorWrapper className="relative">
        <EditorProvider>
          <Editor
            value={interview.notes}
            onChange={(e) => handleOnChange(e.target.value)}
            disabled={isSaving}
            // @ts-ignore
            placeholder="Say something smart..."
          >
            <Toolbar>
              <BtnUndo />
              <BtnRedo />
              <Separator />
              <BtnBold />
              <BtnItalic />
              <BtnUnderline />
              <BtnStrikeThrough />
              <Separator />
              <BtnNumberedList />
              <BtnBulletList />
              <Separator />
              <BtnLink />
              <BtnClearFormatting />
              <HtmlButton />
            </Toolbar>
          </Editor>
        </EditorProvider>

        <div className="absolute right-2.5 top-[5px]">
          <NoteTemplatesDropdown
            disabled={isSaving}
            onChange={handleOnChange}
          />
        </div>
      </StyledEditorWrapper>

      <div className="mt-6">
        <div className="mb-2">
          <b>Video Link</b>
        </div>

        <Input
          fluid
          placeholder="https://video.link/"
          value={interview.videoLink}
          onChange={(e) =>
            setInterview({ ...interview, videoLink: e.target.value })
          }
        />
      </div>

      <div className="mt-6">
        <div className="mb-2">
          <b>Transcript</b>
        </div>

        <EditorProvider>
          <Editor
            value={interview.transcript}
            onChange={(e) =>
              setInterview({ ...interview, transcript: e.target.value })
            }
            disabled={isSaving}
            // @ts-ignore
            placeholder="Paste conversation trascript here..."
          ></Editor>
        </EditorProvider>
      </div>

      <div className="mt-6 text-right">
        <Button
          basic
          disabled={isSaving}
          onClick={() => {
            cleanupForm()
            onCancel?.()
          }}
          type="button"
          content="Cancel"
        />
        <SaveAsTemplateBtn
          disabled={isSaving}
          text={interview.notes}
          askForName
        />
        <Button
          type="submit"
          form={formId}
          content="Save"
          icon="save"
          primary
          loading={isSaving}
          disabled={isSaving}
        />
      </div>
    </div>
  )
}
